<div
  class="chart-list"
  cdkDropList
  [ngStyle]="{ 'min-height': canvasType == 'dashboard' ? 'initial' : '300vh' }"
  (cdkDropListDropped)="drop($event)"
  id="list-1"
>
  <ng-container *ngIf="loading">
    <div class="progress-loader" *ngIf="!chartData || chartData.length <= 0">
      <div class="loading-spinner">
        <mat-spinner strokeWidth="3" diameter="150"></mat-spinner>
        <div
          style="
            position: relative;
            top: -95px;
            left: 3px;
            text-align: center;
            width: 150px;
          "
        ></div>
      </div>
    </div>
  </ng-container>
  <app-blank-chart
    [type]="page"
    *ngIf="!chartData || (chartData.length <= 0 && canvasMode == 'edit')"
  ></app-blank-chart>
  <gridster
    [options]="options"
    *ngIf="chartData && canvasType == 'dashboard' && showGridster()"
    [ngClass]="{ preview: canvasMode == 'view' }"
    [ngClass]="{ dashboard: canvasType == 'dashboard' }"
  >
    <gridster-item
      [item]="chart"
      *ngFor="let chart of dashboard; let i = index; let last = last"
    >
      <div
        class="gridPlaceholder"
        *ngIf="canvasMode == 'edit'"
        [ngClass]="chart.object.data.chartType"
      >
        <ng-container *ngIf="chart.object.data.chartType">
          <fa-icon [icon]="getIcon(chart)"></fa-icon>
          {{ chart.object.data.title || reportTitle }}<BR />
          <span class="chartTitle">
            &quot;{{ chart.object.data.chartType }} chart&quot;
          </span>
        </ng-container>
        <ng-container *ngIf="!chart.object.data.chartType">
          Text object container
        </ng-container>
      </div>
      <!-- your content here -->
      <div class="container grid" *ngIf="canvasMode == 'view'">
        <div
          class="rectangle grid"
          [ngStyle]="styleArray[i]"
          (click)="selectChart(i, chart)"
        >
          <div class="iconSpace">&nbsp;</div>

          <fa-icon
            [icon]="faUpRightAndDownLeftFromCenter"
            *ngIf="chart.canvasItemType == 'chart' && chart.isVisible"
            (click)="openExpandDialog(chart, $event)"
          ></fa-icon>

          <fa-icon
            [icon]="faDownload"
            *ngIf="
              chart.id && chart.isVisible && chart.canvasItemType == 'chart'
            "
            (click)="
              openChartDownloadDialog(
                chart.title || reportTitle,
                chart.id,
                chart,
                $event
              )
            "
          ></fa-icon>
          <fa-icon
            [icon]="faTriangleExclamation"
            *ngIf="
              chart.object.data.showSeriesAlert &&
              canvasMode == 'view' &&
              chart.object.data.chartType != 'Table' &&
              chart.object.data.chartType != 'List'
            "
            class="SeriesAlert"
            matTooltip="This chart exceeds the 15 series limit and is missing information"
          ></fa-icon>
          <div
            *ngIf="chart.canvasItemType == 'chart' && !chart.isVisible"
            class="viewableGrid"
          >
            Unable to display due to security group collection permissions.
            Please contact your administrator for assistance
          </div>
          <div
            *ngIf="chart.canvasItemType == 'chart' && chart.isLoading"
            style="display:flex;align-items:center;justify-content:center;height:100%;"
          >
            <mat-spinner strokeWidth="2" diameter="40"></mat-spinner>
          </div>
          <div
            *ngIf="chart.canvasItemType == 'chart' && chart.isError"
            class="viewableGrid"
          >
            Unable to load chart data. Please refresh the page.
          </div>
          <!-- BEGIN LIST OF CHARTS -->
          <ng-container
            *ngIf="chart.canvasItemType == 'chart' && chart.isVisible && !chart.isLoading && !chart.isError"
          >
            <app-table-chart
              *ngIf="chart.object.data.chartType == 'Table'"
              [data]="chart.object.data.chartObject"
              [chartData]="chart.object.data"
              [dataPoints]="chart.object.data.dataPoints"
              [type]="chart.object.data.chartType"
              [preview]="preview"
              [hasEdit]="hasEdit"
              [fullSize]="true"
            >
            </app-table-chart>
            <app-list-chart
              *ngIf="chart.object.data.chartType == 'List'"
              [data]="chart.object.data.chartObject"
              [chartData]="chart.object.data"
              [dataPoints]="chart.object.data.dataPoints"
              [type]="chart.object.data.chartType"
              [preview]="preview"
              [hasEdit]="hasEdit"
              [fullSize]="true"
              [canvasMode]="canvasMode"
              [canvasType]="canvasType"
            >
            </app-list-chart>
            <app-high-chart
              *ngIf="
                chart.object.data.chartType != 'Table' &&
                chart.object.data.chartType != 'List'
              "
              [data]="chart.object.data.chartObject"
              [type]="chart.object.data.chartType"
              [chartData]="chart.object.data"
              [preview]="preview"
              [hasEdit]="hasEdit"
              [dataPoints]="chart.object.data.dataPoints"
              [canvasType]="canvasType"
            ></app-high-chart>
          </ng-container>
          <!-- END LIST OF CHARTS -->

          <!-- BEGIN LIST OF OBJECTS -->
          <ng-container
            *ngIf="
              chart.canvasItemType == 'textBox' ||
              chart.canvasItemType == 'header' ||
              chart.canvasItemType == 'footer' ||
              chart.canvasItemType == 'image'
            "
            ><span
              class="chartHeader"
              *ngIf="chart.canvasItemType != 'textBox' && !preview && hasEdit"
              >{{ chart.canvasItemType }}</span
            >
            <span
              class="chartHeader"
              *ngIf="
                chart.canvasItemType == 'textBox' &&
                !preview &&
                hasEdit &&
                canvasMode == 'edit'
              "
              >text</span
            >
            <app-text-box
              [data]="chart.object.data.value"
              [type]="chart.canvasItemType"
              [position]="i"
              [preview]="preview"
              [hasEdit]="hasEdit"
              [canvasMode]="canvasMode"
              (chartTextChange)="chartTextChangedHandler($event)"
            ></app-text-box>
          </ng-container>
          <!-- END LIST OF OBJECTS -->
        </div>
      </div>
    </gridster-item>
  </gridster>

  <div *ngIf="chartData && !showGridster()">
    <div
      *ngFor="let chart of chartData; let i = index; let last = last"
      cdkDrag
      id="list-1"
      cdkDragBoundary=".chart-list"
      [cdkDragDisabled]="canvasMode != 'edit'"
      [ngStyle]="itemWidth(chart)"
    >
      <div class="reorder-placeholder" *cdkDragPlaceholder>
        Drop chart here to place in position
      </div>
      <div class="container">
        <div
          class="rectangle"
          [ngStyle]="styleArray[i]"
          (click)="selectChart(i, chart)"
          [ngClass]="{ active: chart.object.data == selectedItem }"
        >
          <fa-icon
            [icon]="faTrash"
            *ngIf="!preview && canvasMode == 'edit'"
            (click)="removeChart($event, i, chart.canvasItemType)"
          ></fa-icon>
          <div class="iconSpace" *ngIf="preview">&nbsp;</div>
          <fa-icon
            [icon]="faUpRightAndDownLeftFromCenter"
            *ngIf="chart.canvasItemType == 'chart'"
            (click)="openExpandDialog(chart, $event)"
          ></fa-icon>

          <fa-icon
            [icon]="faDownload"
            *ngIf="chart.id && chart.canvasItemType == 'chart'"
            (click)="
              openChartDownloadDialog(
                chart.title || reportTitle,
                chart.id,
                chart,
                $event
              )
            "
          ></fa-icon>
          <fa-icon
            [icon]="faTriangleExclamation"
            *ngIf="
              chart.object.data.showSeriesAlert &&
              canvasMode == 'edit' &&
              chart.object.data.chartType != 'Table' &&
              chart.object.data.chartType != 'List'
            "
            class="SeriesAlert"
            matTooltip="This chart exceeds the 15 series limit and is missing information - consider removing one or more series or adding filters"
          ></fa-icon>

          <fa-icon
            [icon]="faTriangleExclamation"
            *ngIf="
              chart.object.data.showSeriesAlert &&
              canvasMode == 'view' &&
              chart.object.data.chartType != 'Table' &&
              chart.object.data.chartType != 'List'
            "
            class="SeriesAlert"
            matTooltip="This chart exceeds the 15 series limit and is missing information"
          ></fa-icon>

          <div
            class="example-handle"
            cdkDragHandle
            *ngIf="!preview && canvasMode == 'edit'"
          >
            <fa-icon [icon]="faGripVertical" class="grip"></fa-icon>
          </div>
          <!-- BEGIN LIST OF CHARTS -->
          <div
            *ngIf="chart.canvasItemType == 'chart' && !chart.isVisible"
            class="viewable"
          >
            Unable to display due to security group collection permissions.
            Please contact your administrator for assistance
          </div>
          <div
            *ngIf="chart.canvasItemType == 'chart' && chart.isLoading"
            style="display:flex;align-items:center;justify-content:center;height:100px;"
          >
            <mat-spinner strokeWidth="2" diameter="40"></mat-spinner>
          </div>
          <div *ngIf="chart.canvasItemType == 'chart' && chart.isError" class="viewable">
            Unable to load chart data. Please refresh the page.
          </div>
          <ng-container
            *ngIf="chart.canvasItemType == 'chart' && chart.isVisible && !chart.isLoading && !chart.isError"
          >
            <app-table-chart
              *ngIf="chart.object.data.chartType == 'Table'"
              [data]="chart.object.data.chartObject"
              [chartData]="chart.object.data"
              [dataPoints]="chart.object.data.dataPoints"
              [type]="chart.object.data.chartType"
              [preview]="preview"
              [hasEdit]="hasEdit"
            >
            </app-table-chart>
            <app-list-chart
              *ngIf="chart.object.data.chartType == 'List'"
              [data]="chart.object.data.chartObject"
              [chartData]="chart.object.data"
              [dataPoints]="chart.object.data.dataPoints"
              [type]="chart.object.data.chartType"
              [preview]="preview"
              [hasEdit]="hasEdit"
              [canvasMode]="canvasMode"
              [canvasType]="canvasType"
            >
            </app-list-chart>
            <app-high-chart
              *ngIf="
                chart.object.data.chartType != 'Table' &&
                chart.object.data.chartType != 'List'
              "
              [data]="chart.object.data.chartObject"
              [chartData]="chart.object.data"
              [type]="chart.object.data.chartType"
              [preview]="preview"
              [hasEdit]="hasEdit"
              [dataPoints]="chart.object.data.dataPoints"
              [canvasType]="canvasType"
            ></app-high-chart>
          </ng-container>
          <!-- END LIST OF CHARTS -->

          <!-- BEGIN LIST OF OBJECTS -->
          <ng-container
            *ngIf="
              chart.canvasItemType == 'textBox' ||
              chart.canvasItemType == 'header' ||
              chart.canvasItemType == 'footer' ||
              chart.canvasItemType == 'image'
            "
            ><span
              class="chartHeader"
              *ngIf="chart.canvasItemType != 'textBox' && !preview && hasEdit"
              >{{ chart.canvasItemType }}</span
            >
            <span
              class="chartHeader"
              *ngIf="
                chart.canvasItemType == 'textBox' &&
                !preview &&
                hasEdit &&
                canvasMode == 'edit'
              "
              >text</span
            >
            <app-text-box
              [data]="chart.object.data.value"
              [type]="chart.canvasItemType"
              [position]="i"
              [preview]="preview"
              [hasEdit]="hasEdit"
              [canvasMode]="canvasMode"
              (chartTextChange)="chartTextChangedHandler($event)"
            ></app-text-box>
          </ng-container>
          <!-- END LIST OF OBJECTS -->
        </div>
      </div>
    </div>
  </div>
</div>
